<div class="max-w-[1216px] mx-auto flex md:gap-4 p-3 md:py-5 md:px-0 " *transloco="let t; currentLang as currentLang">
    <div class="p-3 bg-white flex-1 w-full border border-[#ddddd9] rounded md:px-5 md:py-6 shadow-lg">
        <div class="flex flex-col gap-2 md:flex-row  md:justify-between md:items-center mb-8">
            <button [routerLink]="jobs_url" [queryParams]="{isBack: true}" class=" cursor-pointer">
                <span class="flex gap-1.5 items-center cursor-pointer font-semibold text-[#475467]">
                  <img [src]="environment.homeImageUrl + 'icon-down.svg'" class="rotate-90 w-5 h-5"/>
                  <span>{{t('jobList')}}</span>
                </span>
              </button>
            <p class="text-[#333] text-sm text-center">
                <strong>{{t('source')}} : </strong>
                <span>
                    {{jobDetails()?.JobSource}}
                    ({{ currentLang === 'en' 
                        ? (jobDetails()?.PostedOn | date: 'EEEE, MMMM d, y') 
                        : ((jobDetails()?.PostedOn  | date: 'EEEE, MMMM d, y') ?? '' | toBanglaNumber)
                    }})
                </span>
            </p>
        </div>
        <div class="flex flex-col gap-1.5 mb-2.5">
            <p class="text-sm text-[#5c5c5c]">
                {{jobDetails()?.JobTitle}}
            </p>
            <p class="text-lg text-[#2b882f] font-bold">
                {{jobDetails()?.CompnayName}}
            </p>
        </div>
        @if(jobDetails()?.JObIMage){
            <div class="w-full">
                <img [src]="jobDetails()?.JObIMage!" width="1160" height="400" />
            </div>
        }
        <div class="text-center" (click)="openMoreJobModal()">
            <p class="cursor-pointer text-base text-[#428bca] hover:text-[#2a6496]">{{t('moreNewspaperJob')}}</p>
        </div>
    </div>
    <div>
        <app-ads-panel></app-ads-panel>
    </div>
</div>

@if(isMoreJobModalOpen()){
    <div>
      <app-more-jobs-modal 
          (closeModalEmt)="closeMoreJobModal()"
          [jobList]="moreJobs()" 
          [jobdetails]="jobDetails()"
          [fromNewspaper]="true"
          >
      </app-more-jobs-modal>
    </div>
} 
